import router from '@/router';
import { isEmpty } from 'lodash';
import {
  fetchLogin,
  fetchMe,
  fetchMeEdit,
  fetchMeGet,
} from '@/api/user';

import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  login({ state, commit }) {
    const { email, password } = state.item;
    commit('resetErrors');
    return fetchLogin({ body: { email, password } })
      .then(res => {
        commit('resetPassword');
        commit('setEmail', null);
        if (!res.ok) {
          throw new Error('Wrong Email or Password');
        }
        return res.json();
      })
      .then(res => {
        commit('setToken', res.access_token);
        router.replace({ name: 'dashboard' });
      })
      .catch(e => console.error(e) || commit('addError', e.message))
    ;
  },
  fetch(context) {
    const { commit, dispatch } = context;
    fetchMe()
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        commit('setUser', res);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
  fetchFull(context) {
    const { commit, dispatch } = context;
    fetchMeGet()
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        commit('setUser', res);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
  logout({ commit }) {
    commit('reset');
    router.replace({ name: 'login' });
  },
  save(context, body = {}) {
    if (isEmpty(body)) {
      return;
    }
    const { commit, state, dispatch } = context;

    body.currentPassword = state.currentPassword;
    commit('resetErrors');
    commit('resetPassword');
    commit('resetCurrentPassword');
    return fetchMeEdit({ body })
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('addError', 'Invalid response');
          return true;
        }

        if (res.violations && res.violations.length > 0) {
          commit('setErrors', res.violations);
          return true;
        }

        if (res.detail) {
          commit('addError', res.detail);
          return true;
        }
        if (Array.isArray(res)) {
          res.map(item => {
            if (item.message) {
              commit('addError', item.message);
            }
          });
          return false;
        }
        commit('setUser', res);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
};
